// extracted by mini-css-extract-plugin
export default {"items":"CheckboxGroup_items__jpaC5","checkBox":"CheckboxGroup_checkBox__CeEaI"};